<svg fill="none" class="angle-down" viewBox="0 0 12 8" height="15" width="15">
  <path
    d="m1 1.5 5 5 5-5"
    stroke="#98A2B3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
